import React from 'react'
import { Li } from 'meinian-package/src/baseComponent'
import PriceZone from './index'
import styles from './index.module.less'

export const PriceZoneRange = ({ params, setParams }) => {
  return <Li className="item">
    <span className="label">价格带</span>
    <PriceZone
      minVolume={params.priceStart}
      maxVolume={params.priceEnd}
      changeVolume={(min, max) => {
        setParams(pre => ({ ...pre, priceStart: min, priceEnd: max }))
      }}
    />
  </Li>
}

export const NewPriceZoneRange = ({ value, onChange }) => {
  return <div className={styles.newPriceZoneRange}>
    <div className="newPriceZoneRangeLabel">价格带：</div>
    <PriceZone
      trigger="click"
      minVolume={value[0]}
      maxVolume={value[1]}
      onVisibleChange={(vis) => {
        if (vis && value[0] > value[1] && (value[1] || value[1] === 0)) {
          onChange([value[1], value[0]])
        }
      }}
      changeVolume={(min, max) => {
        onChange([min, max])
      }}
    />
  </div>
}
